import { Component } from "react";
import { Link, Redirect, withRouter } from "react-router-dom";
import axios from "axios";

// Styles
import "./schoolAdmin.css";

// Material Ui
import MaterialTable from "material-table";
import { Button, CircularProgress, Paper } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { FaPen, FaTrash } from "react-icons/fa";
import successimg from "../../assets/images/successimg.png";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
// Services
import userService from "../../services/user.service";
import {
  getFromLocalStorage,
  removeFromLocalStorage,
} from "../../utils/webStorage";

// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";

// Assets
import menuthree from "../../assets/images/menuthree.png";
import close from "../../assets/images/crosstick.png";
import { BsXLg } from "react-icons/bs";
import ErrorMessage from "../../Common/ErrorMessage";
import moment from "moment";
import LongMenu from "../../Common/actionMenu";
import DeleteDialog from "./Popups/DeleteDialog";
import SuccessDialog from "./Popups/SuccessDialog";
import CustomSearch from "../../Common/CustomSearch";
import CommonMenu from "../../Common/CommonMenu";
import ListMenu from "../../Common/ListMenu";
import { connect } from "react-redux";
import ButtonWithToolTip from "../../Common/ButtonWithToolTip";
import SchoolStatus from "./SchoolAdminPages/SchoolStatus/SchoolStatus";
// All Urls

class SchoolCoaches extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allSchoolList: [],
      columns: [],
      cochesSelectedData: [],
      atheletesSelectedData: [],
      deleteId: null,
      anchorEl: null,
      total: null,
      submitting: false,
      schoolId: getFromLocalStorage("schoolId"),
      openDeletePop: false,
      deleteIdForGroup: "",
      redirect: false,
      currentRowId: "",
      pageState: {
        isLoading: false,
        data: [],
        total: 0,
        page: 0,
        pageSize: 10,
      },
      searchQuery: "",
      recordNotFound: false,
      openResetPopUp: false,
      emailToReset: "",
      deletePopup: false,
      currentAthleteId: "",
      msg: "",
      deletePopup: false,
      successPopup: false,
      redirectToRow: false,
      searchQuery: "",
      searchedRecord: false,
      navigateToRedirect: false,
      redirectId: "",
    };
  }

  //pop ups
  openDialog(coach, athelete) {
    let cochesSelectedData = coach;
    let atheletesSelectedData = athelete;
    this.setState({ cochesSelectedData });
    this.setState({ atheletesSelectedData });
    this.setState({ open: !this.state.open });
  }
  closeDialog() {
    this.setState({ open: !this.state.open });
  }
  openDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }
  closeDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }
  openDialogWrong() {
    this.setState({ openWrong: !this.state.openWrong });
  }
  closeDialogWrong() {
    this.setState({ openWrong: !this.state.openWrong });
  }

  openDialogRemoved() {
    this.setState({ openSuccessGroup: !this.state.openSuccessGroup });
  }
  closeDialogRemoved() {
    this.setState({ openSuccessGroup: !this.state.openSuccessGroup });
  }

  //end pop up

  componentDidMount() {
    const { schoolId } = this.state;
    const coachone = document.getElementById("groups");
    if (coachone) {
      coachone.classList.add("btnActive");
    }
    this.setState({ schoolId });
    this.getGroupData(schoolId);
    this.getGroupByPage(
      this.state.pageState.page,
      this.state.pageState.pageSize
    );
  }
  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };
  handleClose = () => {
    this.setState({
      allSchoolList: [],
      columns: [],
      deleteId: null,
      anchorEl: null,
      open: false,
      modalId: "",
    });
  };

  getdeleteID(id) {
    let arr = [];
    arr.push(id);
    this.deleteId = arr;
  }

  getGroupData(schoolId) {
    this.setState({
      submitting: true,
    });
    userService
      .getAllGroups(schoolId)
      .then((response) => {
        if (response.data.status == true) {
          var allSchoolList = response.data.data.groups;
          var groupTotal = response.data.data.total;
          this.setState({ allSchoolList, groupTotal });
          this.setState({
            submitting: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          submitting: false,
        });
        console.error("There was an error!", error);
      });
  }

  closeDialog = () => {
    this.setState({ open: !this.state.open });
  };

  openDeleteDialog = (deleteId) => {
    this.setState({
      openDeletePop: !this.state.openDeletePop,
      deleteIdForGroup: deleteId,
    });
  };

  closeDeleteDialog = () => {
    this.setState({ openDeletePop: !this.state.openDeletePop });
  };
  ConfirmDeleteDialog = () => {
    this.deleteGroups();
  };

  deleteGroups() {
    if (this.state.deleteIdForGroup != "") {
      userService
        .deleteGroupsApi(this.state.deleteIdForGroup)
        .then((response) => {
          if (response.status === 200) {
            this.getGroupData(this.state.schoolId);
            this.closeDeleteDialog();
            this.state.deleteIdForGroup = "";
            this.openDialogRemoved();
          } else {
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  }

  getGroupByPage = (page, size) => {
    const { schoolId, recordNotFound } = this.state;
    this.setState({ pageState: { ...this.state.pageState, isLoading: true } });
    userService
      .getGroupsByPage(schoolId, page, size)
      .then((res) => {
        if (recordNotFound) {
          this.setRecordNotFound();
        }
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: res.data.data.groups,
            isLoading: false,
            total: res.data.data.total,
            page: page,
          },
          submitting: false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ submitting: false });
      });
  };

  setSearchedRecord = (value) => {
    this.setState({ searchedRecord: value });
  };

  setSearchQuery = (value) => {
    this.setState({ searchQuery: value });
  };

  setRecordNotFound = () => {
    this.setState({ recordNotFound: false });
  };

  deleteAthleteDialog = (id) => {
    this.setState({
      deletePopup: true,
      msg: "Are You Sure You Want to Remove this Group?",
      currentAthleteId: id,
    });
  };

  closeAthleteDeleteDialog = () => {
    this.setState({ deletePopup: false });
  };

  deleteCurrentAthlete = () => {
    const { searchedRecord, searchQuery, pageState } = this.state;
    this.deleteAthleteUsingId().then(() => {
      this.setState({
        msg: "Group Removed Successfully",
        successPopup: true,
        deletePopup: false,
      });
      document.body.style.overflow = "unset";
      const newPageNumber =
        pageState.data.length == 1 && pageState.page > 0
          ? pageState.page - 1
          : pageState.page;
      if (searchedRecord) {
        this.searchGroups(searchQuery, newPageNumber, 10);
      } else {
        this.getGroupByPage(newPageNumber, 10);
      }
    });
  };

  deleteAthleteUsingId = () => {
    const { currentAthleteId } = this.state;
    return userService.deleteGroupsApi(currentAthleteId);
  };

  toggleSuccessDialog = () => {
    const { successPopup } = this.state;
    this.setState({ successPopup: !successPopup });
  };

  closeActionDialog = (setValue) => {
    setValue(null);
  };

  searchGroups = (query, page, size) => {
    const { schoolId, searchedRecord } = this.state;
    this.setState({
      pageState: { ...this.state.pageState, isLoading: true },
      searchQuery: query,
    });
    if (!searchedRecord) {
      this.setState({ searchedRecord: true });
    }
    userService
      .searchGroups(query, schoolId, page, size)
      .then((res) => {
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: res.data.data.groups,
            isLoading: false,
            total: res.data.data.total,
            page: page,
          },
          recordNotFound: res.data.data.groups.length == 0 ? true : false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: [],
            isLoading: false,
            total: 0,
            page: page,
          },
          recordNotFound: true,
        });
      });
  };

  menuItemContent = (data) => {
    const arr = [
      {
        id: "1",
        name: "Edit Details",
        icon: <ModeEditIcon className="manage-section-iconss" />,
        ApiCall: this.redirectToEdit,
      },
      {
        id: "2",
        name: "Delete",
        icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
        ApiCall: this.deleteGroupById,
      },
    ];
    return arr;
  };

  deleteGroupById = (data) => {
    this.deleteAthleteDialog(data.id);
  };

  redirectToEdit = (data) => {
    this.setState({ navigateToRedirect: true, redirectId: data.id });
  };
  render() {
    const { submitting } = this.state;
    const {
      redirect,
      currentRowId,
      pageState,
      searchQuery,
      recordNotFound,
      navigateToRedirect,
      redirectId,
      msg,
      successPopup,
      deletePopup,
    } = this.state;
    const { history, currentSeason, isDrawerOpen } = this.props;

    if (redirect) {
      history.push(`/groupdetails/${currentRowId}`);
    }

    if (navigateToRedirect) {
      history.push(`/editgroup/${redirectId}`);
    }

    const tableColumns = [
      {
        field: "firstName",
        headerName: "Name",
        headerAlign: "center",
        headerClassName: "table-header bold",
        flex: 1,
        minWidth: 200,
        sortable: false,
        renderCell: (params) => (
          <div className="d-flex-align-cent height-70 w-100">
            <p className="link-blue text-width-auto mg-auto">
              {params.row.groupName}
            </p>
          </div>
        ),
      },
      {
        field: "signUpDate",
        headerName: "Created On",
        headerClassName: "table-header bold",
        headerAlign: "center",
        align: "center",
        flex: 1,
        minWidth: 250,
        sortable: false,
      },
      {
        field: "createdBy",
        headerName: "Created By",
        headerClassName: "table-header bold",
        headerAlign: "center",
        align: "center",
        flex: 1,
        minWidth: 250,
        sortable: false,
      },
      {
        field: "coachAthleteCount",
        headerName: "Members",
        flex: 1,
        minWidth: 150,
        headerClassName: "table-header bold",
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "status",
        headerName: "Status",
        headerClassName: "table-header bold",
        cellClassName: "mng-z-index",
        align: "center",
        width: 150,
        headerAlign: "center",
        renderCell: (params) => (
          <SchoolStatus status={params.row.status} isDeleted={false} />
        ),
      },
      {
        headerClassName: "table-header bold",
        cellClassName: "mng-z-index2",
        headerAlign: "center",
        align: "center",
        sortable: false,
        height: 100,
        renderCell: (params) => (
          <div>
            <ListMenu
              menuContent={this.menuItemContent(params.row)}
              rowData={params.row}
            />
          </div>
        ),
      },
    ];

    return (
      <div>
        <div
          className={
            isDrawerOpen ? "content-layout p-0" : "toggle-content-layout p-0"
          }
        >
          <div className="dynamic-height">
            <div>
              <SchoolAdminDashboard />
              <div className="mng-header">
                <h4 className="fs-24 black bold mob-hd">
                  Groups ({pageState.total})
                </h4>
                {currentSeason ? (
                  <Link to="/addgroup">
                    <button className="addBtnn2 mng-padding">
                      <AddIcon className="mr-2 addIconSc " />
                      Create Group
                    </button>
                  </Link>
                ) : (
                  <ButtonWithToolTip
                    buttonText="Create Group"
                    toolTipText="Please Create New Season Before Creating Group"
                  />
                )}
              </div>

              {submitting && (
                <div className="content-layout-loading-animation">
                  <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
                    <CircularProgress
                      className="rounded-circle"
                      color="success"
                      sx={{ fontSize: 10, color: "#002244" }}
                      disableShrink
                    />
                  </div>
                </div>
              )}

              <div className="col-12 col-sm-12 col-md-12 col-lg-12 plr dynamic-height">
                {!submitting &&
                  (pageState.data.length > 0 || recordNotFound) && (
                    <Paper className="pad-top-20">
                      <CustomSearch
                        searchQuery={searchQuery}
                        setSearchQuery={this.setSearchQuery}
                        setSearchedRecord={this.setSearchedRecord}
                        searchedRecord={this.state.searchedRecord}
                        getDataByPage={this.getGroupByPage}
                        pageState={pageState}
                        searchData={this.searchGroups}
                        setRecordNotFound={this.setRecordNotFound}
                      />
                      <DataGrid
                        rows={pageState.data}
                        rowCount={pageState.total}
                        loading={pageState.isLoading}
                        pagination
                        page={pageState.page}
                        columns={tableColumns}
                        pageSize={pageState.pageSize}
                        rowsPerPageOptions={[10]}
                        paginationMode="server"
                        onPageChange={(newPage) => {
                          if (searchQuery == "") {
                            this.getGroupByPage(newPage, 10);
                          } else {
                            this.searchGroups(searchQuery, newPage, 10);
                          }
                          this.setState({ ...pageState, page: newPage });
                        }}
                        onPageSizeChange={(newPageSize) =>
                          this.setState({
                            ...pageState,
                            pageSize: newPageSize,
                          })
                        }
                        sx={{
                          color: "black",
                          fontFamily: "Rajdhani-SemiBold",
                          fontSize: "18px",
                          backgroundColor: "white",
                          borderBottomLeftRadius: "12px",
                          borderBottomRightRadius: "12px",
                        }}
                        onCellClick={(param) => {
                          this.setState({
                            redirect: true,
                            currentRowId: param.row.id,
                          });
                        }}
                        autoHeight
                        disableColumnMenu
                        getRowHeight={() => "auto"}
                      />
                    </Paper>
                  )}
                <div className="clear20" />
              </div>
            </div>
            {!submitting && pageState.data.length == 0 && !recordNotFound && (
              <div className="content-layout-loading-animation">
                <p className="fs-20 bold">No Groups Found</p>
              </div>
            )}
          </div>

          {/* SOMTHING WENT WRONG modal pop up */}
          <Dialog
            id="dialogBoxWrong"
            className="dialog-style"
            open={this.state.openWrong || false}
            onClose={this.closeDialogWrong.bind(this)}
          >
            <DialogTitle>
              <div className="row">
                <div className="col-1 text-right ml-auto ">
                  <BsXLg
                    onClick={this.closeDialogWrong.bind(this)}
                    className="crossview cp"
                  ></BsXLg>
                </div>
              </div>
            </DialogTitle>
            <DialogContent>
              <div className="clear10"></div>
              <div className="row">
                <div className="col-12 text-center">
                  <p className="fs-20 semi-bold text-center">
                    Something Went Wrong..!
                  </p>
                  <div className="clear10"></div>
                </div>
                <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                  <button
                    type="button"
                    class="donebtn"
                    onClick={this.closeDialogWrong.bind(this)}
                  >
                    DONE
                  </button>
                </div>
              </div>

              <div className="clear10"></div>

              <div className="clear10"></div>
            </DialogContent>
          </Dialog>

          <DeleteDialog
            open={deletePopup}
            closeDialog={this.closeAthleteDeleteDialog}
            deleteRecord={this.deleteCurrentAthlete}
            deleteId={null}
            msg={msg}
          />

          <SuccessDialog
            successPopUp={successPopup}
            toggleSuccessDialog={this.toggleSuccessDialog}
            msg={msg}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentSeason: state.loggedInUser.userProfile.currentSeason,
    isDrawerOpen: state?.schoolAdminDashboardInformation.isDrawerOpen,
  };
};

export default withRouter(connect(mapStateToProps)(SchoolCoaches));
